import * as React from "react";
import { useNavigate } from "react-router-dom";
import { createValueCatalog } from "src/business/valueCatalog/apiValueCatalog";
import { ZValueCatalog } from "src/business/valueCatalog/ZValueCatalog";
import { mdmBreadcrumbs } from "src/common/mdmBreadcrumbs";
import { msgQueueStore } from "src/components/MsgQueue";
import { PageLayout } from "src/components/PageLayout";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { ValueCatalogForm } from "../ValueCatalogForm";

export const ManagValueCatalogNew: React.FC = () => {
  const navigate = useNavigate();
  const title = "Новый каталог значений";
  const onSuccess = ({ id }: ZValueCatalog) => {
    msgQueueStore.add({
      type: "success",
      message: "Выполнено создание каталога значений",
    });
    navigate(makeUrl(PageUrl.managementValueCatalogEdit, { id }), {
      replace: true,
    });
  };
  return (
    <PageLayout
      title={mdmBreadcrumbs([
        { type: "ObjAndSpecs" },
        { type: "AdminValueCatalogs" },
        { type: "Name", name: title },
      ])}
    >
      <ValueCatalogForm
        title={title}
        okText="Создать"
        onSubmit={createValueCatalog}
        onSuccess={onSuccess}
      />
    </PageLayout>
  );
};
